import { rolesEn } from '@verantos-dev/core-auth';
import {
  appLayoutMessagesEn,
  enterpriseLoginMessagesEn,
  sidebarMessagesEn,
} from '@verantos-dev/core-localization';
import { cohortAttritionTableMessagesEn } from '@verantos-dev/feature-cohort-attrition';
import { cohortBuilderPageMessagesEn } from '@verantos-dev/feature-cohort-builder';
import { cohortCharacteristicsMessagesEn } from '@verantos-dev/feature-cohort-characteristics';
import { cohortsListMessageKeysEn } from '@verantos-dev/feature-cohort-list';
import { conceptGroupsMessagesEn } from '@verantos-dev/feature-concept-groups-list';
import { dataReliabilityKeyFn } from '@verantos-dev/feature-data-reliability';
import { datasetDeliveryMessagesEn } from '@verantos-dev/feature-dataset-delivery';
import { organizationsMessagesEn } from '@verantos-dev/feature-organizations-list';
import { projectsListMessageKeysEn } from '@verantos-dev/feature-projects-list';
import { researchAssistantMessagesEn } from '@verantos-dev/feature-research-assistant';
import { cohortBuilderSubjectsListMessagesEn } from '@verantos-dev/feature-subjects-list';
import { usersMessagesEn } from '@verantos-dev/feature-users-list';
import { dataGridMessagesEn } from '@verantos-dev/shared-components';

import { sharedLocale } from './shared.en';
export default {
  ...sharedLocale,
  ...appLayoutMessagesEn,
  ...sidebarMessagesEn,
  ...enterpriseLoginMessagesEn,
  ...dataGridMessagesEn,
  ...usersMessagesEn,
  ...projectsListMessageKeysEn,
  ...cohortBuilderPageMessagesEn,
  ...cohortAttritionTableMessagesEn,
  ...cohortBuilderSubjectsListMessagesEn,
  ...cohortCharacteristicsMessagesEn,
  ...researchAssistantMessagesEn,
  ...organizationsMessagesEn,
  ...datasetDeliveryMessagesEn,
  ...cohortsListMessageKeysEn,
  ...dataReliabilityKeyFn,
  ...rolesEn,
  ...conceptGroupsMessagesEn,
};
